import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PaginationUtilService } from '@app/core/services/pagination-util.service';

@Injectable({
  providedIn: 'root',
})
export class LibrarySortParamsResolver {
  constructor(private readonly paginationUtil: PaginationUtilService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let playlistRoute = false;
    if (state.url.indexOf('/playlist/') > 0) {
      playlistRoute = true;
    }
    const sort = route.queryParams['sort']
      ? route.queryParams['sort']
      : playlistRoute
      ? 'position,asc'
      : 'uploadDate,desc';

    return {
      predicate: this.paginationUtil.parsePredicate(sort),
      ascending: this.paginationUtil.parseAscending(sort),
    };
  }
}
